import React from 'react';
import { Toast } from '@base-ui/react/toast';
import { cn } from '@/lib/cn';

export function ToastProvider({ children }: { children: React.ReactNode }) {
  return <Toast.Provider>{children}</Toast.Provider>;
}

// Keyed by the `type` passed to useToast()'s helpers (see hooks/useToast.ts).
// success/warning route through the severity tokens (green/orange) rather
// than the brand accent, which is a maroon close enough to sev-critical to
// read as an error at a glance.
const TONE: Record<string, string> = {
  success: 'border-sev-low',
  error: 'border-sev-critical',
  warning: 'border-sev-high',
  info: 'border-ink',
};

export function Toaster() {
  const { toasts } = Toast.useToastManager();
  return (
    <Toast.Portal>
      <Toast.Viewport className="fixed bottom-4 left-4 z-[60] flex w-[calc(100vw-2rem)] max-w-sm flex-col gap-2">
        {toasts.map((t) => (
          <Toast.Root
            key={t.id}
            toast={t}
            className={cn(
              'relative border bg-paper-raised p-3 pr-8 text-ink shadow',
              TONE[String(t.type)] ?? TONE.info,
            )}
          >
            <Toast.Title className="text-scale-1 font-semibold" />
            <Toast.Description className="text-scale-0 text-ink-muted" />
            <Toast.Close
              aria-label="Dismiss"
              className="absolute right-2 top-2 cursor-pointer text-ink-muted hover:text-ink"
            >
              &#x2715;
            </Toast.Close>
          </Toast.Root>
        ))}
      </Toast.Viewport>
    </Toast.Portal>
  );
}
